import { render, staticRenderFns } from "./LayoutInventiry.vue?vue&type=template&id=53b91ec8&scoped=true"
import script from "./LayoutInventiry.vue?vue&type=script&lang=js"
export * from "./LayoutInventiry.vue?vue&type=script&lang=js"
import style0 from "./LayoutInventiry.vue?vue&type=style&index=0&id=53b91ec8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b91ec8",
  null
  
)

export default component.exports